import React from 'react';
import { Intent, ProgressBar } from "@blueprintjs/core";

const toast_uploadSuccess = () => ({
    icon: 'tick',
    intent: Intent.SUCCESS,
    message: 'Successful file hosting !',
    timeout: 2000
})

const toast_uploadInProgress = (progress) => ({
    icon: 'cloud-upload',
    message: (
        <ProgressBar
            intent={progress < 100 ? Intent.NONE : Intent.SUCCESS}
            value={progress / 100} />
    ),
    timeout: 0
})

const toast_uploadError = () => ({
    icon: 'warning-sign',
    intent: Intent.DANGER,
    message: 'We were unable to host the file...',
    timeout: 2000
})

const toast_deleteSuccess = () => ({
    icon: 'tick',
    intent: Intent.SUCCESS,
    message: 'The file has been deleted !',
    timeout: 2000
})

const toast_deleteError = (str) => ({
    icon: 'warning-sign',
    intent: Intent.DANGER,
    message: str || 'We were unable to delete the file...',
    timeout: 2000
})

const toast_warningError = (str, timeout) => ({
    icon: 'warning-sign',
    intent: Intent.WARNING,
    message: str,
    timeout: timeout
})

export {
    toast_uploadSuccess,
    toast_uploadInProgress,
    toast_deleteSuccess,
    toast_deleteError,
    toast_warningError,
    toast_uploadError
}